export const routesProje = [
  {
    path: "/proje",
    name: "proje",
    component: () => import("@/views/proje/index.vue"),
    meta: {
      public: false,
      title: "Proje",
      yetki: { k: [1010802] },
    },
  },
]
